// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Admin API service for legislative review application settings.
 */
import { getWorkspacesApi } from '@/subsystems/workspaces/services/api'

/** Single datasource with its enabled sessions and admin workspace */
export interface DatasourceConfig {
  id: string
  sessions: string[]
  adminOrgId?: string | null
  adminWorkspaceId?: string | null
}

/** Application settings for legislative review */
export interface LegislativeReviewSettings {
  title?: string | null
  datasources?: DatasourceConfig[] | null
}

/** Request payload for updating settings */
export interface UpdateSettingsRequest {
  title?: string | null
  datasources?: DatasourceConfig[] | null
}

export type LegislativeReviewAdminApi = ReturnType<typeof useLegislativeReviewAdminApi>

export const useLegislativeReviewAdminApi = () => {
  const apiInstance = getWorkspacesApi()

  return {
    /**
     * Fetch current application settings.
     */
    fetchSettings: async (): Promise<LegislativeReviewSettings> => {
      const url = '/admin/application/legislative-review/config'
      const res = await apiInstance.get<LegislativeReviewSettings>(url)
      return res.data
    },

    /**
     * Update application settings.
     */
    updateSettings: async (settings: UpdateSettingsRequest): Promise<LegislativeReviewSettings> => {
      const url = '/admin/application/legislative-review/config'
      const res = await apiInstance.post<LegislativeReviewSettings>(url, settings)
      return res.data
    },
  }
}
